import { BroadcastMediatorService } from "@core/services/broadcast-mediator.service";
import { Component, OnInit } from "@angular/core";
import { ThemeService } from "asksuite-citrus";
import {LogEvent} from "@core/enums/log-event";
import {LoggerService} from "@core/services/logger.service";

type Theme = 'light' | 'dark';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
})
export class ThemeToggleComponent implements OnInit {

  theme: Theme = 'light'

  constructor(
    private readonly themeService: ThemeService,
    private readonly logger: LoggerService
  ) {
    this.theme = this.themeService.getTheme();
  }

  ngOnInit(): void {
    this.themeService.listenThemeChange().subscribe((theme: Theme) => {
      this.theme = theme;
    });
  }

  toggleTheme(){
    this.theme = this.theme === 'dark' ? 'light' : 'dark';
    this.themeService.setTheme(this.theme);
    this.logger.log(
      LogEvent.LIVECHAT_DARK_MODE,
      {
        activated: this.theme === 'dark'
      }
    );
    this.sendThemeToApps()
  }

  sendThemeToApps(){
    BroadcastMediatorService.notify('theme', this.theme)
  }

}
